<template>
  <BaseList listSubtitulo="Lista de construções" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-success font-bold mb-1 w-100 rounded etapa_construcao" :data-id="data.id"
                    :data-desc="data.imovel">
              <i class="fa fa-list"></i> ETAPA CONSTRUÇÃO
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('editar', data.id, data.key, data.imovel)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, data.imovel)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarConstrucoes
      v-if="modalAtivo === 'cadastro'"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <EditarConstrucao
      v-if="modalAtivo === 'editar'"
      :idModal="'editarModal'"
      :imovelDescricao="imovelDescricao"
      :itemKey="itemKeySelect"
      @fechar="fecharModal"
      @atualizarDados="atualizaDados"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarConstrucoes from "./CadastrarConstrucoes.vue";
import EditarConstrucao from "./EditarConstrucao.vue";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaConstrucoes",
  components: {
    BaseList,
    CadastrarConstrucoes,
    EditarConstrucao,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      imovelDescricao: null,
      itemSelect: null,
      itemKeySelect: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'imovel', header: 'IMÓVEL',},
        {field: 'data_inicio', header: 'DATA INÍCIO', align: 'text-center',},
        {field: 'tempo_construcao', header: 'TEMPO CONSTRUÇÃO (MESES)', align: 'text-right',},
        {field: 'data_termino_previsao', header: 'DATA PREVISÃO DE TÉRMINO', align: 'text-center',},
        {field: 'data_termino', header: 'DATA TÉRMINO', align: 'text-center',},
        {field: 'previsao_orcamentaria', header: 'PREVISÃO ORÇAMENTÁRIA(R$)', align: 'text-right',},
        {field: 'orcamento_atual', header: 'ORÇAMENTO ATUAL(R$)', align: 'text-right',},
        {field: 'diferenca_orcamento', header: 'DIFERENÇA(R$)', align: 'text-right', body: row => row.diferenca_orcamento || ''},
      ]
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, id = null, key = null, descricao) {
      this.modalAtivo = tipo;
      if (descricao) {
        this.imovelDescricao = descricao
      }
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemkey, itemId, itemNome) {
      let url = apiUrl.construcoes.retrieveUpdateDestroy(itemkey);
      alertDelete(itemkey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.construcoes.createList, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.etapa_construcao');
      if (button) {
        const construcaoId = button.getAttribute('data-id');
        const construcaoDesc = button.getAttribute('data-desc');

        this.$router.push({name: 'construcao_etapas', query: {construcaoId, construcaoDesc}});
      }
    })
  }
};
</script>
